import React, { useContext } from 'react';
import { useWidget } from 'state/widget/context';
import { WidgetUnit } from 'types';
import { UnitIdContextType } from './types';

interface UnitIdProviderProps {
  children?: React.ReactNode;
  unitId: string;
}

const UnitIdContext = React.createContext<UnitIdContextType | undefined>(
  undefined,
);

export const UnitIdProvider: React.FC<UnitIdProviderProps> = ({
  children,
  unitId,
}) => (
  <UnitIdContext.Provider value={{ unitId }}>{children}</UnitIdContext.Provider>
);

export function useUnitId() {
  const context = useContext(UnitIdContext);

  if (context === undefined) {
    throw new Error('useUnitId must be used within a UnitIdProvider');
  }

  return context;
}

export function useUnit(): WidgetUnit | undefined {
  const { unitId } = useUnitId();
  const {
    state: { units },
  } = useWidget();

  return !units || !unitId ? undefined : units[unitId];
}

export function useFlagUnit() {
  const unit = useUnit();
  const { state } = useWidget();

  const canFlag = unit?.isSponsored && state.flagUnitFeature;
  const displayFlaggedState = unit
    ? state.flaggedUnits.includes(unit.resultId)
    : false;
  return { canFlag, displayFlaggedState };
}
